import {DetailValue} from 'mc/lib';
import {formatCurrency, formatDate} from 'mc/lib/utils/commons';
import * as PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import {Card, CardBlock, CardHeader, Col, Row} from 'reactstrap';
import * as FormaUhradyInfo from '../../api/FormaUhradyInfo';

export default class PlatbaUdajeCard extends PureComponent {

    static propTypes = {
        platba: PropTypes.object.isRequired
    };

    render() {
        const {platba} = this.props;
        return (
            <Card>
                <CardHeader>
                    <h2>Základní údaje</h2>
                </CardHeader>
                <CardBlock>
                    <Row>
                        <Col xs={6} sm={4} lg={3}>
                            <DetailValue label="Číslo dokladu">
                                {platba.cisloDokladu}
                            </DetailValue>
                        </Col>
                        <Col xs={6} sm={4} lg={3}>
                            <DetailValue label="VS">
                                {platba.vs}
                            </DetailValue>
                        </Col>
                        <Col xs={6} sm={4} lg={3}>
                            <DetailValue label="Datum platby">
                                {formatDate(platba.datumPlatby)}
                            </DetailValue> </Col>
                        <Col xs={6} sm={4} lg={3}>
                            <DetailValue label="Forma úhrady">
                                {FormaUhradyInfo.getCaption(platba.formaUhrady)}
                            </DetailValue>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6} sm={4} lg={3}>
                            <DetailValue label="Částka platby">
                                {formatCurrency(platba.castkaPlatby)}
                            </DetailValue>
                        </Col>
                        <Col xs={6} sm={4} lg={3}>
                            <DetailValue label="Částka vyrovnání">
                                {formatCurrency(platba.castkaVyrovnani)}
                            </DetailValue>
                        </Col>
                        <Col xs={6} sm={4} lg={3}>
                            <DetailValue label="K vrácení / vráceno">
                                {formatCurrency(platba.vratkaNerealizovana)} / {formatCurrency(platba.vratkaRealizovana)}
                            </DetailValue>
                        </Col>
                        <Col xs={6} sm={4} lg={3}>
                            <DetailValue label="Zdroj">
                                {platba.zdroj}
                            </DetailValue>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6} sm={4} lg={3}>
                            <DetailValue label="Číslo účtu">
                                {platba.cisloUctu}
                            </DetailValue>
                        </Col>
                        <Col xs={12} sm={8}>
                            <DetailValue label="Poznámka">
                                {platba.poznamka}
                            </DetailValue>
                        </Col>
                    </Row>
                </CardBlock>
            </Card>
        );
    }
}
